export const enum CAMPAIGN_ACCESS {
  LINK = 'link',
  EMAIL = 'email',
  CODE = 'code',
  EMAIL_AND_CODE = 'email_and_code',
}
